import { render, staticRenderFns } from "./articulos-detalles-observaciones.vue?vue&type=template&id=2c1a84e9&scoped=true&"
import script from "./articulos-detalles-observaciones.vue?vue&type=script&lang=ts&"
export * from "./articulos-detalles-observaciones.vue?vue&type=script&lang=ts&"
import style0 from "./articulos-detalles-observaciones.vue?vue&type=style&index=0&id=2c1a84e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a84e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
